import React, { Component } from "react";
import styled from "styled-components";

const Section = styled.div `
    input {
        color: black;
    }
    .signup-step input[type=email] {
        color: black !important;

    }
    .signup-step .su-field-entry {
        color: black !important;
    }
    input#signup-email-address.su-field-entry{
        color: black !important;
    }
`

export default class Signup extends Component {
  componentDidMount() {
    const script = document.createElement("script");

    script.src = "https://public.govdelivery.com/assets/Signup.js";
    script.async = true;
    const signupId = "data-signup-id"
    const dataAccCode = "data-account-code"
    script.signupId = "31487"
    script.dataAccCode = "UKEDDC"


    document.body.appendChild(script);
    const scriptToUse = window.scriptTarget
  }

  render() {
    return (
      <div>
          <Section style={{color: "black"}}>
              {this.scriptToUse}
          </Section>
        <script
        id="scriptTarget"
        data-account-code= "UKEDDC"
        data-signup-id= "31487"></script>
      </div>
    );
  }
}